import { useState, useContext, useEffect } from "react";

import { DiscoveryContext } from "./discovery-context";
import { fetchGpt4API } from "../../services/apiService";
import { extractJSONFromString } from "../../utils/helpers";
import { PRODUCT_PREF_PROMPT } from "./../../utils/constant";

export default function useProductPreference() {
  const discoveryCtx = useContext(DiscoveryContext);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      discoveryCtx.updateProductPrefs([]);
    }
  }, [discoveryCtx.abort_launch]);

  async function getProductPrefs() {
    try {
      const prompt = PRODUCT_PREF_PROMPT.replace(
        "[Category]",
        discoveryCtx.category
      );
      let response = await fetchGpt4API(
        prompt,
        new AbortController(),
        1000,
        1,
        "gpt-4o"
      );
      response = await extractJSONFromString(response["GPT-4"][0]);
      if (response && response?.data) {
        const fetchedPrefs = response?.data;
        discoveryCtx.updateProductPrefs(fetchedPrefs);
      }
      return response;
    } catch (err) {
      console.error(err);
    }
  }

  return { getProductPrefs };
}
